import { useState } from 'react';
import { format } from 'date-fns';
import Collapse from 'react-bootstrap/Collapse';
import Menu from '@layouts/footer/menu/Menu';
import logo from '@assets/images/footer-logo.png';



const Footer = () => {

	const [ open, setOpen ] = useState(false);

	return (
		<div className='layout-footer'>
			
			<div className='footer-path'>
				<p>{'CT Reporting > Moji zákazníci > Přehled'}</p>
			</div>

			<Collapse in={open}>
				<div id='collapse-menu'>
					<Menu />
				</div>
			</Collapse>
			
			<div className='footer-brand' onClick={() => setOpen(!open)}>
				
				<p>© {format(new Date(), 'yyyy')} Plzeňský Prazdroj, a.s.</p>
				
				<div className='footer-logo'>
					<img
						src={logo}
						alt='footer-brand-logo' />
				</div>
			
			</div>
			
		</div>
	);
}

export default Footer;